import { render } from "./EarnRewards.vue?vue&type=template&id=77623070"
import script from "./EarnRewards.vue?vue&type=script&lang=js"
export * from "./EarnRewards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__